import { keyframes } from "@emotion/react";

export const pulse = keyframes`
    0% {
        opacity: 0.5;
    }
    50% {
        opacity: 1.5;
    }
    100% {
        opacity: 0.5;
    }
`;
